<table>
    <thead>
    <tr>
        <th class="analogs-table__column analogs-table__column--brand">Stream </th>
        <th class="analogs-table__column analogs-table__column--brand">Sub Stream</th>

        <th class="analogs-table__column analogs-table__column--name">Course Name</th>
        <th class="analogs-table__column analogs-table__column--price">Course Price</th>
        <th class="analogs-table__column analogs-table__column--brand">Apply Course</th>

    </tr>
    </thead>
    <tbody>
    <tr *ngFor="let analog of course">
        <td class="analogs-table__column analogs-table__column--name">
            <a [routerLink]="url.product(analog)" class="analogs-table__product-name">{{ analog.main_category.name }}</a><br>
            <!-- <div class="analogs-table__sku" [attr.data-title]="'TABLE_SKU'|translate">{{ analog.sku }}</div> -->
        </td>
        <td class="analogs-table__column analogs-table__column--name">
            <a [routerLink]="url.product(analog)" class="analogs-table__product-name">{{ analog.sub_category.name }}</a><br>
            <!-- <div class="analogs-table__sku" [attr.data-title]="'TABLE_SKU'|translate">{{ analog.sku }}</div> -->
        </td>
        <td class="analogs-table__column analogs-table__column--name">
            <a [routerLink]="url.product(analog)" class="analogs-table__product-name">{{ analog.course_name }}</a><br>
            <!-- <div class="analogs-table__sku" [attr.data-title]="'TABLE_SKU'|translate">{{ analog.sku }}</div> -->
        </td>
        <!-- <td class="analogs-table__column analogs-table__column--rating">
            <div class="analogs-table__rating">
                <div class="analogs-table__rating-stars">
                    <app-rating [value]="analog.rating"></app-rating>
                </div>
                <div class="analogs-table__rating-label">
                    {{ 'TEXT_RATING_LABEL'|translate:{rating: analog.rating, reviews: analog.reviews} }}
                </div>
            </div>
        </td> -->
        <!-- <td class="analogs-table__column analogs-table__column--brand" [attr.data-title]="'TABLE_BRAND'|translate">
            {{ analog.brand.name }}
            <div class="analogs-table__country">({{ 'COUNTRY_NAME_' + analog.brand.country|translate }})</div>
        </td> -->
        <td class="analogs-table__column analogs-table__column--price">
            {{ analog.course_fees }}
        </td>
        <td class="analogs-table__column analogs-table__column--price">
            <button
                type="submit"
                class="btn btn-primary mt-3"
                (click)="apply(analog)"
            >
                Apply
            </button>
        </td>
    </tr>
    </tbody>
</table>


  <!-- Modal -->
  <div class="modal fade" id="exampleModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="exampleModalLabel">Modal title</h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          ...
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
          <button type="button" class="btn btn-primary">Save changes</button>
        </div>
      </div>
    </div>
  </div>
